'use client'

import { Fragment, ReactNode, useEffect, useState } from 'react'

import { Container } from '../../components/container'
import { useBreakpoints } from '../../hooks/use-breakpoints'
import { BaseSlider } from './base-slider'

export const BaseResizingCMSSlider = ({
  elements,
  numberOfColumns,
  interval,
  color,
}: {
  elements: ReactNode[]
  numberOfColumns: number
  /** ms between slides */
  interval?: number
  /** hex color value */
  color?: string
}) => {
  const breakpoints = useBreakpoints()
  const [slides, setSlides] = useState<ReactNode[][]>([])
  const [numberPerSlide, setNumberPerSlide] = useState(5)

  useEffect(() => {
    setSlides(parseSlides())
  }, [elements, numberPerSlide])

  useEffect(() => {
    if (breakpoints.isDesktop) {
      setNumberPerSlide(numberOfColumns)
    } else if (breakpoints.isTablet) {
      setNumberPerSlide(numberOfColumns > 2 ? 2 : numberOfColumns)
    } else {
      // mobile
      setNumberPerSlide(1)
    }
  }, [breakpoints])

  const parseSlides = () => {
    const slides: ReactNode[][] = []
    let slide: ReactNode[] = []
    elements.forEach((p, i) => {
      if (slide.length < numberPerSlide) {
        slide.push(p)
      } else {
        slides.push(slide)
        slide = []
        slide.push(p)
      }

      if (i === elements.length - 1 && slide.length > 0) {
        // reached end fill out rest of slide
        let i = 0
        while (slide.length < numberPerSlide) {
          const product = elements[i]
          if (!product) {
            throw new Error('could not find testimonial in array')
          }
          slide.push(product)
          i++
          if (i >= elements.length) {
            i = 0
          }
        }

        slides.push(slide)
        slide = []
      }
    })
    return slides
  }

  return (
    <BaseSlider key={numberPerSlide} interval={interval} color={color}>
      {slides.map((slide, i) => (
        <Container key={i} className="pb-6 sm:pb-0 my-12">
          <div
            data-testid="slider-slide"
            className="grid gap-6"
            style={{ gridTemplateColumns: `repeat(${slide.length}, 1fr)` }}
          >
            {slide.map((s, i) => (
              <Fragment key={i}>{s}</Fragment>
            ))}
          </div>
        </Container>
      ))}
    </BaseSlider>
  )
}
